<template>
    <div v-if="isHotelLoaded()">

        <h3>{{ hotel.title }}</h3>

        <b-tabs>

            <b-tab>
                <template slot="title">
                    <i class="icon-calculator"></i> Публичное
                </template>

                <h4>Публичные данные</h4>

                <div class="row">

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Город" class="required" description="[t_city_id]">
                            <b-form-select id="citySelet"
                                           :plain="true"
                                           v-model="hotel.t_city_id"
                                           :options="cities"
                                           value-field="id"
                                           text-field="title"
                                           placeholder="Выберите город">
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group :label="'Тип объекта ' + hotel.t_type_id"
                                      class="required"  description="[t_type_id]">

                            <b-form-select id="typeSelet"
                                           :plain="true"
                                           v-model="hotel.t_type_id"
                                           :options="htypes"
                                           value-field="id"
                                           text-field="title"
                                           placeholder="Выберите город">
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Наименование"  class="required" description="[title]">
                            <input v-model="hotel.title" class="form-control" required />
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Человеческий URL" class="required" description="[hurl]">
                            <input v-model="hotel.hurl" class="form-control"/>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Полное наименование"  description="[title_full]">
                            <input v-model="hotel.title_full" class="form-control"/>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Почтовый индекс" description="[mail_index]">
                            <input v-model="hotel.mail_index" class="form-control"/>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Адрес" description="Адрес (без указания индекса и города) [address]">
                            <input v-model="hotel.address" class="form-control"/> <!-- 150 -->
                        </b-form-group>
                    </div>

                    <div class="col-6 col-md-4 col-lg-2">
                        <b-form-group label="Время расчетов" description="Время расчетов (расчетный час) ЧЧ:ММ [time_check_payment]">
                            <time-input v-model="hotel.time_check_payment"></time-input>
                        </b-form-group>
                    </div>

                    <div class="col-6 col-md-4 col-lg-2">
                        <b-form-group label="Время заезда" description="Время заезда (час в сутках) ЧЧ:ММ [time_check_in]">
                            <time-input v-model="hotel.time_check_in"></time-input>
                        </b-form-group>
                    </div>

                    <div class="col-6 col-md-4 col-lg-2">
                        <b-form-group label="Время выезда" description="Время выезда (час в сутках) ЧЧ:ММ [time_check_out]">
                            <time-input v-model="hotel.time_check_out"></time-input>
                        </b-form-group>
                    </div>

                    <div class="col-6 col-md-4 col-lg-2">
                        <b-form-group label="Количество «звезд»" description="[stardom]">
                            <input v-model="hotel.stardom" class="form-control" />
                        </b-form-group>
                    </div>

                    <div class="col-6 col-md-4 col-lg-2">
                        <b-form-group label="Широта" description="[maps_coordinates_latitude]">
                            <input v-model="hotel.maps_coordinates_latitude" class="form-control" />
                        </b-form-group>
                    </div>

                    <div class="col-6 col-md-4 col-lg-2">
                        <b-form-group label="Долгота" description="[maps_coordinates_longitude]">
                            <input v-model="hotel.maps_coordinates_longitude" class="form-control" />
                        </b-form-group>
                    </div>


                    <div class="col-md-6">
                        <b-form-group label="Краткое описание" description="[description]">
                            <textarea v-model="hotel.description" class="form-control" ></textarea>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Описание [HTML]" description="[content_html_general]">
                            <textarea v-model="hotel.content_html_general" class="form-control" ></textarea>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Лечение [HTML]" description="[content_html_healing]">
                            <textarea v-model="hotel.content_html_healing" class="form-control" ></textarea>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Номерной фонд [HTML]" description="[content_html_rooms]">
                            <textarea v-model="hotel.content_html_rooms" class="form-control" ></textarea>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Питание [HTML]" description="[content_html_diet]">
                            <textarea v-model="hotel.content_html_diet" class="form-control" ></textarea>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Досуг [HTML]" description="[content_html_leisure]">
                            <textarea v-model="hotel.content_html_leisure" class="form-control" ></textarea>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label="Бронирование [HTML]"  description="[content_html_booking] ">
                            <textarea v-model="hotel.content_html_booking" class="form-control " ></textarea>
                        </b-form-group>
                    </div>
                </div>

                <button class="btn btn-secondary" @click="onCancel()">Отменить</button> &nbsp;
                <button class="btn btn-success" @click="onApply()">Сохранить и продолжить</button> &nbsp;
                <button class="btn btn-success" @click="onSave()">Сохранить и завершить</button> &nbsp;

            </b-tab>

            <b-tab >
                <template slot="title">
                    <i class="icon-calculator"></i> Служебное
                </template>

                <div class="row">

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Контролирующая компания"
                                      :description="field_name_for_god ('company_id')">
                            <b-form-select id="companySelet"
                                           :plain="true"
                                           v-model="hotel.company_id"
                                           :options="companies"
                                           value-field="id"
                                           text-field="title"
                                           placeholder="Выберите компанию">
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Телефоны"
                                      :description="field_name_for_god ('phones')">
                            <input v-model="hotel.phones" class="form-control"/><!--300 -->
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Email"
                                      :description="field_name_for_god ('email')">
                            <input v-model="hotel.email" class="form-control"/> <!--100 -->
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="URL"  description="без http:// "
                                      :description="field_name_for_god ('url')">
                            <input v-model="hotel.url" class="form-control"/><!--200 -->
                        </b-form-group>
                    </div>



                </div>
                <div class="row">


                    <div class="col-md-12 col-lg-6">
                        <b-form-group label="Дополнительные контакты"
                                      :description="'(только для системы)' + field_name_for_god ('contacts_other')">
                            <textarea v-model="hotel.contacts_other" class="form-control" :rows="9" />
                        </b-form-group>
                    </div>

                    <div class="col-md-12 col-lg-6">
                        <b-form-group label="Дополнительная информация"
                                      :description="'(для агентств)' + field_name_for_god ('info_other')">
                            <textarea v-model="hotel.info_other" class="form-control" :rows="9"/>
                        </b-form-group>
                    </div>

                    <div class="col-md-12 col-lg-6">
                        <b-form-group label="Условия сотрудничества"
                                      :description="field_name_for_god ('cooperation')">
                            <textarea v-model="hotel.cooperation" class="form-control" :rows="9" />
                        </b-form-group>
                    </div>


                </div>

                <h2>Бронирование</h2>

                <div class="row">

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Система бронирования"
                                      :description="field_name_for_god ('booker_id')">
                            <b-form-select id="bookerSelet"
                                           :plain="true"
                                           v-model="hotel.booker_id"
                                           :options="bookers"
                                           value-field="id"
                                           text-field="title"
                                           placeholder=""
                                           @change="onChangeBooker"
                            >
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4" v-if="hotel.booker_id">
                        <b-form-group :label="'Идентификатор объекта во внешней системе: #'+hotel.external_id"
                                      :description="field_name_for_god('external_id')">
                            <v-select
                                :plain="true"
                                v-model.number="hotel.external_id"
                                :options="booker_hotels"
                                label="title"
                                :reduce="x=>x.id"
                                placeholder="Выберите объект"
                            >
                            </v-select>
                        </b-form-group>
                    </div>

                </div>

                <div class="row"  v-if="hotel.booker_id">
                    <div class="col-md-6 col-lg-4">
                        <b-form-group
                            :description="'Запрет внешней системы бронирования (профкурорта)'+field_name_for_god ('extern_disabled')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="extern_disabled" value="1"
                                       v-model="hotel.extern_disabled">
                                <label class="custom-control-label" for="extern_disabled">оформление путевок через
                                    внешнюю систему запрещено</label>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group
                            :description="'Синхронизация со внешней системой бронирования (профкурортом)'+field_name_for_god ('extern_sync')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="extern_sync" value="1"
                                       v-model="hotel.extern_sync">
                                <label class="custom-control-label" for="extern_sync">синхронизация со внешней системой
                                    включена</label>
                            </div>
                        </b-form-group>
                    </div>
                </div>


                <div class="row">

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Размер предоплаты, %"
                                      :description="field_name_for_god ('sys_contract_prepayment_size')">
                            <input v-model="hotel.sys_contract_prepayment_size" class="form-control"/>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Кол-во дней на предоплату"
                                      :description="field_name_for_god ('sys_contract_prepayment_day')">
                            <input v-model="hotel.sys_contract_prepayment_day" class="form-control"/>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4"  >
                        <b-form-group label="Кол-во дней полную оплату"
                                      :description="field_name_for_god ('sys_contract_payment_full_day')">
                            <input v-model="hotel.sys_contract_payment_full_day" class="form-control"/>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4"  >
                        <b-form-group label="Тип вознаграждения"
                                      :description="field_name_for_god ('sys_reward_type')">
                            <b-form-select id="rewardSelet"
                                           :plain="true"
                                           v-model="hotel.sys_reward_type"
                                           :options="reward_types"
                                           value-field="id"
                                           text-field="title">
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4"  >
                        <b-form-group label="Тип выставляемого счета"
                                      :description="field_name_for_god ('sys_invoice_type')">
                            <b-form-select id="invoice_typeSelet"
                                           :plain="true"
                                           v-model="hotel.sys_invoice_type"
                                           :options="invoice_types"
                                           value-field="id"
                                           text-field="title">
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4"  >
                        <b-form-group label="Тип оплаты счета"
                                      :description="field_name_for_god ('sys_payment_type')">
                            <b-form-select id="payment_typeSelet"
                                           :plain="true"
                                           v-model="hotel.sys_payment_type"
                                           :options="payment_types"
                                           value-field="id"
                                           text-field="title">
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Оплата в кассу объекта"
                                      :description="field_name_for_god ('direct_payment')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="direct_payment" value="1" v-model="hotel.direct_payment">
                                <label class="custom-control-label" for="direct_payment">разрешена оплата в кассу объекта</label>
                            </div>
                        </b-form-group>
                    </div>

                </div>

                <h2>Опции</h2>

                <div class="row">

                    <div class="col-md-6 col-lg-4">
                        <b-form-group :description="field_name_for_god ('m_transition_disabled')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="m_transition_disabled" value="1" v-model="hotel.m_transition_disabled">
                                <label class="custom-control-label" for="m_transition_disabled">расчет по цене на дату заезда</label>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group :description="field_name_for_god ('m_manual')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="m_manual" value="1" v-model="hotel.m_manual">
                                <label class="custom-control-label" for="m_manual">места под запрос</label>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group :description="field_name_for_god ('m_bad_site_original')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="m_bad_site_original" value="1" v-model="hotel.m_bad_site_original">
                                <label class="custom-control-label" for="m_bad_site_original">плохой официальный сайт учреждения</label>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group :description="field_name_for_god ('m_image_header')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="m_image_header" value="1" v-model="hotel.m_image_header">
                                <label class="custom-control-label" for="m_image_header">в наличии имеется картинка фасада</label>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group :description="field_name_for_god ('m_ready')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="m_ready" value="1" v-model="hotel.m_ready">
                                <label class="custom-control-label" for="m_ready">объект размещения полностью заполнен (оформлен)</label>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group :description="field_name_for_god ('m_disabled')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="m_disabled" value="1" v-model="hotel.m_disabled">
                                <label class="custom-control-label" for="m_disabled">объект отключен</label>
                            </div>
                        </b-form-group>
                    </div>

<!--                    <div class="col-md-6 col-lg-4">-->
<!--                        <b-form-group :description="'Используйте поле Система бронирования'+field_name_for_god ('extern_disabled')" class=" alert-warning">-->
<!--                            <div class="custom-control custom-checkbox custom-control-inline">-->
<!--                                <input type="checkbox" class="custom-control-input" id="extern_disabled" value="1" v-model="hotel.extern_disabled">-->
<!--                                <label class="custom-control-label" for="extern_disabled">оформление путевок через ПРОФКУРОРТ закрыто</label>-->
<!--                            </div>-->
<!--                        </b-form-group>-->
<!--                    </div>-->


                </div>

                <h2>Договор</h2>

                <div class="row">

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Тип организации" :description="field_name_for_god ('sys_legal_type')" >
                            <b-form-select id="legal_typeSelet"
                                           :plain="true"
                                           v-model="hotel.sys_legal_type"
                                           :options="orgtypes"
                                           value-field="id"
                                           text-field="title"
                                           placeholder="Выберите тип" >
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-3 col-lg-2">
                        <b-form-group label="ИНН" :description="field_name_for_god ('sys_inn')">
                            <input v-model="hotel.sys_inn" class="form-control"/>
                        </b-form-group>
                    </div>

                    <div class="col-md-3 col-lg-2">
                        <b-form-group label="КПП" :description="field_name_for_god ('sys_kpp')">
                            <input v-model="hotel.sys_kpp" class="form-control"/>
                        </b-form-group>
                    </div>

                </div>

                <div class="row">


                    <div class="col-md-12 col-lg-6">
                        <b-form-group label="Условия бронирования с объектом"
                                      :description="field_name_for_god ('sys_conditions_booking_obj')">
                            <textarea v-model="hotel.sys_conditions_booking_obj" class="form-control" :rows="9" />
                        </b-form-group>
                    </div>

                    <div class="col-md-12 col-lg-6">
                        <b-form-group label="Условия бронирования с клиентом (для договора)"
                                      :description="field_name_for_god ('sys_conditions_booking_client')">
                            <textarea v-model="hotel.sys_conditions_booking_client" class="form-control" :rows="9" />
                        </b-form-group>
                    </div>


                    <div class="col-md-12 col-lg-6">
                        <b-form-group label="Условия и сроки оплаты с объектом"
                                      :description="field_name_for_god ('sys_conditions_payment_obj')">
                            <textarea v-model="hotel.sys_conditions_payment_obj" class="form-control" :rows="9" />
                        </b-form-group>
                    </div>

                    <div class="col-md-12 col-lg-6">
                        <b-form-group label="Условия и сроки оплаты с клиентом (для договора)"
                                      :description="field_name_for_god ('sys_conditions_payment_client')">
                            <textarea v-model="hotel.sys_conditions_payment_client" class="form-control" :rows="9" />
                        </b-form-group>
                    </div>

                    <div class="col-md-12 col-lg-6">
                        <b-form-group label="Условия и сроки аннуляции (штрафов) с объектом"
                                      :description="field_name_for_god ('sys_conditions_cancellation_obj')">
                            <textarea v-model="hotel.sys_conditions_cancellation_obj" class="form-control" :rows="9" />
                        </b-form-group>
                    </div>

                    <div class="col-md-12 col-lg-6">
                        <b-form-group label="Условия и сроки аннуляции (штрафов) с клиентом (для договора)"
                                      :description="field_name_for_god ('sys_conditions_cancellation_client')">
                            <textarea v-model="hotel.sys_conditions_cancellation_client" class="form-control" :rows="9" />
                        </b-form-group>
                    </div>

                </div>

                <div class="row">

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="№ договора с НСБ"
                                      :description="field_name_for_god ('nsb_contract_number')">
                            <input v-model="hotel.nsb_contract_number" class="form-control"/> <!-- max 30 -->
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Дата начала договора с НСБ"
                                      label-for="nsb_contract_date_begin"
                                      :description="field_name_for_god ('nsb_contract_date_begin')"
                                      :invalid-feedback="veeErrors.first('nsb_contract_date_begin')"
                        >
                            <b-input-group style="witdh:100%">
                                <v-date-picker
                                    v-model='_nsb_contract_date_begin'
                                    id="nsb_contract_date_begin"
                                    name="nsb_contract_date_begin"
                                    data-vv-as="'Дата начала договора с НСБ'"
                                    :state="validateState('nsb_contract_date_begin')"
                                    v-validate="{required:true}"
                                    :attributes="datepicker_attributes"
                                >
                                    <b-form-input
                                        type="text"
                                        id="nsb_contract_date_begin_input"
                                        slot-scope="{ inputProps, inputEvents, isDragging }"
                                        class="form-control form-date-picker"
                                        readonly
                                        :state="validateState('nsb_contract_date_begin')"
                                        v-bind="inputProps"
                                        v-on="inputEvents" />
                                </v-date-picker>
                                <button type="button" class="btn btn-secondary" @click.prevent="hotel.nsb_contract_date_begin=null"><i class="fa fa-times"></i></button>
                            </b-input-group>
                        </b-form-group>
                    </div>


                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Дата конца договора с НСБ"
                                      label-for="nsb_contract_date_end"
                                      :description="field_name_for_god ('nsb_contract_date_end')"
                                      :invalid-feedback="veeErrors.first('nsb_contract_date_end')"
                        >
                            <b-input-group style="witdh:100%">
                                <v-date-picker
                                    v-model='_nsb_contract_date_end'
                                    id="nsb_contract_date_end"
                                    name="nsb_contract_date_end"
                                    data-vv-as="'Дата конца договора с НСБ'"
                                    :state="validateState('nsb_contract_date_end')"
                                    v-validate="{required:true}"
                                    :attributes="datepicker_attributes"
                                >
                                    <b-form-input
                                        type="text"
                                        id="nsb_contract_date_end_input"
                                        slot-scope="{ inputProps, inputEvents, isDragging }"
                                        class="form-control form-date-picker"
                                        readonly
                                        :state="validateState('nsb_contract_date_end')"
                                        v-bind="inputProps"
                                        v-on="inputEvents" />
                                </v-date-picker>
                                <button type="button" class="btn btn-secondary" @click.prevent="hotel.nsb_contract_date_end=null"><i class="fa fa-times"></i></button>
                            </b-input-group>
                        </b-form-group>
                    </div>



                    <div class="col-md-12 col-lg-6">
                        <b-form-group :description="field_name_for_god ('nsb_contract_m_auto_extension')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="nsb_contract_m_auto_extension" value="1" v-model="hotel.nsb_contract_m_auto_extension">
                                <label class="custom-control-label" for="nsb_contract_m_auto_extension">договор с автоматической пролонгацией</label>
                            </div>
                        </b-form-group>

                        <b-form-group :description="field_name_for_god ('nsb_contract_m_sender')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="nsb_contract_m_sender" value="1" v-model="hotel.nsb_contract_m_sender">
                                <label class="custom-control-label" for="nsb_contract_m_sender">договор отправлен</label>
                            </div>
                        </b-form-group>

                        <b-form-group :description="field_name_for_god ('nsb_contract_m_subscribed')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="nsb_contract_m_subscribed" value="1" v-model="hotel.nsb_contract_m_subscribed">
                                <label class="custom-control-label" for="nsb_contract_m_subscribed">договор подписан и получен</label>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-12 col-lg-6">
                        <b-form-group label="Комментарий к договору" :description="field_name_for_god ('nsb_contract_comment')">
                            <textarea v-model="hotel.nsb_contract_comment" class="form-control" :rows="9" />
                        </b-form-group>
                    </div>
                </div>

                <h2>Проценты</h2>

                <div class="row">

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Процент вознаграждения для «НСБ» от объекта размещения"
                                      :description="field_name_for_god ('procent_ref_obj')">
                            <input v-model="hotel.procent_ref_obj" class="form-control"/>
                        </b-form-group>
                    </div>

                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Процент комиссионных «НСБ» с путевок"
                                      :description="field_name_for_god ('sys_commission_obj_procent')">
                            <input v-model="hotel.sys_commission_obj_procent" class="form-control"/>
                        </b-form-group>
                    </div>



                    <div class="col-md-6 col-lg-4">
                        <b-form-group label="Дата, когда начали действовать процентные ставки"
                                      label-for="date_interest_start_iso"
                                      :description="field_name_for_god ('date_interest_start_iso')"
                                      :invalid-feedback="veeErrors.first('date_interest_start_iso')"
                        >
                            <b-input-group style="witdh:100%">
                                <v-date-picker
                                    v-model='_date_interest_start_iso'
                                    id="date_interest_start_iso"
                                    name="date_interest_start_iso"
                                    data-vv-as="'Дата, когда начали действовать процентные ставки'"
                                    :state="validateState('date_interest_start_iso')"
                                    v-validate="{required:true}"
                                    :attributes="datepicker_attributes"
                                >
                                    <b-form-input
                                        type="text"
                                        id="date_interest_start_iso_input"
                                        slot-scope="{ inputProps, inputEvents, isDragging }"
                                        class="form-control form-date-picker"
                                        readonly
                                        :state="validateState('date_interest_start_iso')"
                                        v-bind="inputProps"
                                        v-on="inputEvents" />
                                </v-date-picker>
                                <button type="button" class="btn btn-secondary" @click.prevent="hotel.date_interest_start_iso=null"><i class="fa fa-times"></i></button>
                            </b-input-group>
                        </b-form-group>
                    </div>



                    <div class="col-md-6 col-lg-4">
                        <b-form-group :description="field_name_for_god ('calculate_public_prices_using_margin')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="calculate_public_prices_using_margin" value="1" v-model="hotel.calculate_public_prices_using_margin">
                                <label class="custom-control-label" for="calculate_public_prices_using_margin">калькуляция цен через наценку</label>
                            </div>
                        </b-form-group>
                    </div>


                    <div class="col-md-6 col-lg-4">
                        <b-form-group :description="field_name_for_god ('floating_commission')">
                            <div class="custom-control custom-checkbox custom-control-inline">
                                <input type="checkbox" class="custom-control-input" id="floating_commission" value="1" v-model="hotel.floating_commission">
                                <label class="custom-control-label" for="floating_commission">плавающая коммиссия</label>
                            </div>
                        </b-form-group>
                    </div>

                </div>

                <br /><br /><br />

                <button class="btn btn-secondary" @click="onCancel()">Отменить</button> &nbsp;
                <button class="btn btn-success" @click="onApply()">Сохранить и продолжить</button> &nbsp;
                <button class="btn btn-success" @click="onSave()">Сохранить и завершить</button> &nbsp;

            </b-tab>

            <b-tab>
                <template slot="title" ><i class="fa fa-puzzle-piece"></i> Параметры</template>

                <div class="row">
                    <div class="col col-12">
                        <b-form-group label="Основные заболевания">
                            <multiselect
                                v-model="hotel.main_diseases"
                                :options="diseases"
                                :multiple="true"
                                label="title"
                                track-by="title"></multiselect>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-12">
                        <b-form-group label="Заболевания">
                            <multiselect
                                v-model="hotel.diseases"
                                :options="diseases"
                                :multiple="true"
                                label="title"
                                track-by="title"></multiselect>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-12">
                        <b-form-group label="Услуги отеля">
                            <multiselect
                                v-model="hotel.services"
                                :options="services"
                                :multiple="true"
                                label="title"
                                track-by="title"></multiselect>
                        </b-form-group>
                    </div>
                </div>

                <button class="btn btn-secondary" @click="onCancel()">Отменить</button> &nbsp;
                <button class="btn btn-success" @click="onApply()">Сохранить и продолжить</button> &nbsp;
                <button class="btn btn-success" @click="onSave()">Сохранить и завершить</button> &nbsp;

            </b-tab>

            <b-tab>
                <template slot="title" ><i class="fa fa-photo"></i> Фото</template>

                <div class="table-responsive-sm">
                    <table aria-busy="false" class="table table-sm table-striped table-hover table-bordered table-sm ">
                        <thead role="rowgroup" class="">
                        <tr role="row">
                            <th role="columnheader" scope="col" aria-colindex="1" class="">Превью</th>
                            <th role="columnheader" scope="col" aria-colindex="2" class="">Подпись</th>
                            <th role="columnheader" scope="col" aria-colindex="3" class="">Порядок</th>
                            <th role="columnheader" scope="col" aria-colindex="3" class="">Удалить</th>
                        </tr>
                        </thead>

                        <tr v-for="img in fHotelImages()">
                            <td><img :src="img.tn_url" alt="" style="width:80px;height:80px;"></td>
                            <td>
                                <input v-model="img.title" class="form-control">
                                <small>{{img.orig_fn}}</small>
                            </td>
                            <td>
                                <button class="btn btn-primary btn-sm" @click="onDown(img.id)">
                                    <i class="cui-chevron-bottom"></i>
                                </button> &nbsp;
                                <button class="btn btn-primary btn-sm" @click="onUp(img.id)">
                                    <i class="cui-chevron-top"></i>
                                </button>
                            </td>
                            <td>
                                <button class="btn btn-danger btn-sm" @click="onDeleteImage(img.id)">
                                    <i class="fa fa-times"></i>
                                </button>
                            </td>
                        </tr>
                    </table>
                    <button class="btn btn-success" @click="onSaveImageState">Сохранить позиции и подписи</button>
                </div>
                <images-upload :saveurl="hotelImagesSaveUrl" :refname="'uploadh'+hotel.id"  @goodtimetoreload="reloadImages"></images-upload>
                <br/><br/>
            </b-tab>

            <b-tab>
                <template slot="title">
                    <i class="fa fa-hotel"></i> Номера
                </template>
                <div class="btn-group pull-right mb-2">
                    <button class="btn btn-success btn-sm" @click="onAddRoom()">Добавить номер</button>
                </div>
                <v-client-table :data="rooms" :columns="roomTableColumns" :options="roomTableOptions" class="table-sm">
                    <span slot="m_disabled" slot-scope="props" >
                        <a href="#" v-if="props.row.m_disabled" @click.prevent="onEnableRoom(props.row.id)"><i class="cui-lightbulb text-secondary fa-lg" title="номер отключен"></i></a>
                        <a href="#" v-if="!props.row.m_disabled" @click.prevent="onDisableRoom(props.row.id)"><i class="cui-lightbulb text-warning fa-lg" title="номер активен"></i></a>
                    </span>
                    <a slot="edit_room" slot-scope="props" href="#" @click.prevent="showRoomEditDialogId=props.row.id"><i class="fa fa-edit fa-lg text-primary"></i></a>
                    <a slot="clone_room" slot-scope="props" href="#" @click.prevent="onCloneRoom(props.row)"><i class="fa fa-clone fa-lg text-primary"></i></a>
                    <a slot="delete_room" slot-scope="props" href="#" @click.prevent="onDeleteRoom(props.row)"><i class="fa fa-trash fa-lg text-danger"></i></a>
                </v-client-table>

                <p><small>
                    Удаление программы приводит к безвозвратному удалению всей информации связанной сданным программой - цен, скидок
                </small></p>

            </b-tab>

            <b-tab>
                <template slot="title">
                    <i class="fa fa-fire-extinguisher"></i> Программы
                </template>
                <div class="btn-group pull-right mb-2">
                    <button class="btn btn-success btn-sm" @click="onAddProgram()">Добавить программу</button>
                </div>
                <v-client-table :data="programs" :columns="programTableColumns" :options="programTableOptions" class="table-sm"  id="programsTable" ref="programsTable">
                    <span slot="m_disabled" slot-scope="props">
                        <a  href="#" v-if="props.row.m_disabled" @click.prevent="onEnableProgram(props.row.id)"><i class="cui-lightbulb text-secondary fa-lg" title="программа отключена"></i></a>
                        <a href="#" v-if="!props.row.m_disabled" @click.prevent="onDisableProgram(props.row.id)"><i class="cui-lightbulb text-warning fa-lg" title="программа активна"></i></a>
                    </span>
                    <a slot="edit_program" slot-scope="props" href="#" @click.prevent="showProgramEditDialogId=props.row.id"><i class="fa fa-edit fa-lg text-primary"></i></a>
                    <a slot="clone_program" slot-scope="props" href="#" @click.prevent="onCloneProgram(props.row)"><i class="fa fa-clone fa-lg text-primary"></i></a>
                    <a slot="delete_program" slot-scope="props" href="#" @click.prevent="onDeleteProgram(props.row)"><i class="fa fa-trash fa-lg text-danger"></i></a>
                </v-client-table>

                <p>
                    Удаление следует выполнять когда обнаружена ошибка или когда программа совсем перестает существовать.
                    В настоящий момент при удалении нет контроля связности, поэтому ссылки на удаленный программа будут оставаться в
                    ценах, скидках, фотографиях (и возможно еще де-то)
                </p>

            </b-tab>

            <b-tab>
                <template slot="title">
                    <i class="fa fa-calendar"></i> Периоды
                </template>
                <div class="btn-group pull-right mb-2">
                    <button class="btn btn-success btn-sm" @click="onAddPeriod()">Добавить период</button>
                </div>
                <v-client-table :data="_periods" :columns="periodTableColumns" :options="periodTableOptions" class="table-sm">
                    <span slot="m_disabled" slot-scope="props">
                        <a  href="#" v-if="props.row.m_disabled" @click.prevent="onEnablePeriod(props.row.id)"><i class="cui-lightbulb text-secondary fa-lg" title="период отключен"></i></a>
                        <a href="#" v-if="!props.row.m_disabled" @click.prevent="onDisablePeriod(props.row.id)"><i class="cui-lightbulb text-warning fa-lg" title="период активен"></i></a>
                    </span>

                    <span slot="date_period_begin_iso" slot-scope="props">{{ printDate(props.row.date_period_begin_iso) }}</span>
                    <span slot="date_period_end_iso" slot-scope="props">{{ printDate(props.row.date_period_end_iso) }}</span>
                    <a slot="edit_period" slot-scope="props" href="#" @click.prevent="showPeriodEditDialogId=props.row.id"><i class="fa fa-edit fa-lg text-primary"></i></a>
                    <a slot="clone_period" slot-scope="props" href="#" @click.prevent="onClonePeriod(props.row)"><i class="fa fa-clone fa-lg text-primary"></i></a>
                    <a slot="delete_period" slot-scope="props" href="#" @click.prevent="onDeletePeriod(props.row)"><i class="fa fa-trash fa-lg text-danger"></i></a>
                </v-client-table>
            </b-tab>

            <b-tab>
                <template slot="title" ><i class="fa fa-child"></i> Тарифы</template>

                <table class="table table-bordered table-sb table-hover">

                    <tr>
                        <th>
                            Возраст с, включительно
                            <br><small>Минимальный возраст действия тарифа</small>
                        </th>
                        <th>
                            Возраст до, включительно
                            <br><small>Максимальный возраст действия тарифа</small>
                        </th>
                        <th>Тип тарифа</th>
                    </tr>

                    <tr>
                        <td> 0 </td>
                        <td>
                            <select v-model.number="hotel.child_age1" name="hotel.child_age1" @change="onChangeAge1" class="form-control">
                                <option v-for="i in ages.slice(0,19)" :key="i" :value="i"> {{i}}</option>
                            </select>
                        </td>
                        <td>
                            <b-select v-model="hotel.tarif_type1" :options="age_tarifs" text-field="title" value-field="id"></b-select>
                        </td>
                    </tr>

                    <tr v-if="hotel.child_age1<17">
                        <td> {{xxxxxx1p()}}  </td>
                        <td>
                            <select v-model.number="hotel.child_age2" name="hotel.child_age2" @change="onChangeAge2" class="form-control">
                                <option v-for="i in ages.slice(xxxxxx1p(),19)" :key="i" :value="i"> {{i}}</option>
                            </select>
                        </td>
                        <td>
                            <b-select v-model="hotel.tarif_type2" :options="age_tarifs" text-field="title" value-field="id"></b-select>
                        </td>
                    </tr>

                    <tr v-if="hotel.child_age2<17">
                        <td> {{xxxxxx2p()}}  </td>
                        <td>
                            <select v-model.number="hotel.child_age3" name="hotel.child_age3" @change="onChangeAge3" class="form-control">
                                <option v-for="i in ages.slice(xxxxxx2p(),19)" :key="i" :value="i"> {{i}}</option>
                            </select>
                        </td>
                        <td>
                            <b-select v-model="hotel.tarif_type3" :options="age_tarifs" text-field="title" value-field="id"></b-select>
                        </td>
                    </tr>

                    <tr v-if="hotel.child_age3<17">
                        <td> {{xxxxxx3p()}} </td>
                        <td>
                            <select v-model.number="hotel.child_age4" name="hotel.child_age4" @change="onChangeAge4" class="form-control">
                                <option v-for="i in ages.slice(xxxxxx3p(),19)" :key="i" :value="i"> {{i}}</option>
                            </select>
                        </td>
                        <td>
                            <b-select v-model="hotel.tarif_type4" :options="age_tarifs" text-field="title" value-field="id"></b-select>
                        </td>
                    </tr>

                    <tr v-if="hotel.child_age4<17">
                        <td> {{xxxxxx4p()}} </td>
                        <td>
                            <select v-model.number="hotel.child_age5" name="hotel.child_age5" @change="onChangeAge5" class="form-control">
                                <option v-for="i in ages.slice(xxxxxx4p(),19)" :key="i" :value="i"> {{i}}</option>
                            </select>
                        </td>
                        <td>
                            <b-select v-model="hotel.tarif_type5" :options="age_tarifs" text-field="title" value-field="id"></b-select>
                        </td>
                    </tr>

                    <tr v-if="hotel.child_age5<17">
                        <td> {{xxxxxx5p()}}</td>
                        <td> 17 </td>
                        <td>
                            <b-select v-model="hotel.tarif_type6" :options="age_tarifs" text-field="title" value-field="id"></b-select>
                        </td>
                    </tr>
                    <div class="flex-form__separ" v-if="hotel.child_age5<17"></div>

                </table>

                <br>

                <button class="btn btn-secondary" @click="onCancel()">Отменить</button> &nbsp;
                <button class="btn btn-success" @click="onApply()">Сохранить и продолжить</button> &nbsp;
                <button class="btn btn-success" @click="onSave()">Сохранить и завершить</button> &nbsp;

                <br><br>

                <h3>Тарифы (старые) - справочно</h3>
                <ul>
                    <li v-for="program in programs" :key="program.id">{{program.title}}</li>
                </ul>

                <h3>Пояснения</h3>
                <ul>
                    "Базовая цена" - это использование основных цен (для взрослых и тем кто к ним приравнен). Если выбрано это значение то цены для данного возраста не будут вводиться а будут взяты  из цен Базовые.<br>
                    "Младенцы бесплатно без места" - это бесплатное размещение младенцев без отдельного места<br>
                    "Младенцы не допускаются" - в данный объект отдыха младенцы не допускаются и бронирование не может быть выполнено<br>
                    "Льготная цена" - это размещение <br>
                    "Бесплатно с местом" - это для тех случаев, когда программа расчитанная строго на 2-х человек - например "мать и дитя" и для программы есть только 1 цена (без деления на взрослые-дети) - то следует для взрослого указывать стоимость этой программы, а для детей выбирать "Бесплатно с местом".<br>
                </ul>

            </b-tab>

            <b-tab @show="onPricesShow('show')" @focus="onPricesShow('focus')" @change="onPricesShow('change')" @click="onPricesShow('click')">
                <template slot="title">
                    <i class="fa fa-rub"></i> Цены
                </template>

                <div class="row mb-2">
                    <div class="col">
                        <div class="pull-right">
                            <button class="btn btn-success btn-sm" @click="onAddPrices()"><i class="fa fa-plus fa-lg"></i> Создать недостающие цены</button> &nbsp;
                            <button class="btn btn-ghost-primary btn-sm" @click="onDisableChecked()"><i class="cui-lightbulb fa-lg text-secondary"></i> Отключить выбранные</button> &nbsp;
                            <button class="btn btn-ghost-success btn-sm" @click="onEnableChecked()"><i class="cui-lightbulb fa-lg text-warning"></i> Включить выбранные</button> &nbsp;
                            <button class="btn btn-ghost-danger btn-sm" @click="onResetChecked()"><i class="fa fa-times fa-lg"></i> Обнулить выбранное</button> &nbsp;
                            <button class="btn btn-ghost-danger btn-sm" @click="onDeleteChecked()"><i class="fa fa-trash fa-lg"></i> Удалить выбранное</button>
                        </div>
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col col-lg-4">
                        <b-input-group>
                            <b-select
                                :options="active_rooms"
                                v-model="roomFilter"
                                class="form-contol"
                                value-field="id"
                                text-field="title"
                            >
                            </b-select>
                            <button class="btn btn-secondary"  @click="roomFilter=null"><i class="fa fa-times"></i></button>
                        </b-input-group>
                    </div>
                    <div class="col col-lg-4">
                        <b-input-group>
                            <b-select
                                :options="active_programs"
                                v-model="programFilter"
                                label="title"
                                class="form-contol"
                                value-field="id"
                                text-field="title"
                            >
                            </b-select>
                            <button class="btn btn-secondary"  @click="programFilter=null"><i class="fa fa-times"></i></button>
                        </b-input-group>
                    </div>
                    <div class="col col-lg-4">
                        <b-input-group>
                            <b-select
                                v-model="periodFilter"
                                label="title"
                                class="form-contol"
                            >
                                <option v-for="p in active_periods" :value="p.id">с {{ printDate(p.date_period_begin_iso) }} до {{ printDate(p.date_period_end_iso) }} - {{ p.title }}</option>
                            </b-select>
                            <button class="btn btn-secondary"  @click="periodFilter=null"><i class="fa fa-times"></i></button>
                        </b-input-group>

                    </div>
                </div>

                <template v-if="is_prices_loaded">
<!--                    {{ checked_prices }} {{ checked_prices_all }}-->
                    <v-client-table :data="filtered_prices" :columns="priceTableColumns" :options="priceTableOptions" class="table-sm"  id="pricesTable" ref="pricesTable">

                        <div slot="beforeTable" class="pl-2">
                            <b-checkbox v-model="checked_prices_all" @click="onCheckAll" @input="onCheckAll">выбрать все</b-checkbox>
                            <small>"Выбор всего" происходит только на текущей странице, все остальные опции на других страницах будут сброшены как при выделении так и при снятии.</small>
                        </div>

                        <span slot="checkbox" slot-scope="props">
                            <b-checkbox v-model="checked_prices" :value="(props.row.id)"></b-checkbox>
                        </span>

                        <span slot="begin_at" slot-scope="props">{{ printDate(props.row.begin_at) }}</span>
                        <span slot="end_at" slot-scope="props">{{ printDate(props.row.end_at) }}</span>
                        <span slot="period_title" slot-scope="props">{{ props.row.period_title }}</span>

                        <span slot="m_disabled" slot-scope="props">
                            <a  href="#" v-if="props.row.m_disabled" @click.prevent="onEnablePrice(props.row.id)"><i class="cui-lightbulb fa-lg text-secondary" title="цена отключена"></i></a>
                            <a href="#" v-if="!props.row.m_disabled" @click.prevent="onDisablePrice(props.row.id)"><i class="cui-lightbulb fa-lg text-warning" title="цена активна"></i></a>
                        </span>

                        <span slot="price_room" slot-scope="props">{{ formatPriceKop(props.row.pf00) }}</span>
                        <span slot="price_1perroom" slot-scope="props">{{ formatPriceKop(props.row.pf01) }}</span>
                        <span slot="price_place" slot-scope="props">{{ formatPriceKop(props.row.pr00) }}</span>
                        <span slot="price_extra" slot-scope="props">{{ formatPriceKop(props.row.pr01) }}</span>


                        <a slot="edit_price" slot-scope="props" href="#" @click.prevent="showPriceEditDialogId=props.row.id"><i class="fa fa-edit fa-lg text-primary"></i></a>
                        <a slot="delete_price" slot-scope="props" href="#" @click.prevent="onDeletePrice(props.row.id)"><i class="fa fa-trash fa-lg text-danger"></i></a>
                    </v-client-table>

<!--                    {{visible_rows}}-->
                </template>

                <p><small>
                    При добавлении программы, периода или номера для него должны создаваться цены. Если же по каким-то причинам вы видите что нет цен, то:<br>
                    1) пишите мне задачу "№ программы № периода № Номера - нет цены.
                    Также укажите когда был создан последний программа/периода/Номера (из тех, для которых не найдена цена)<br>
                    2) Жмете кнопку "Создать недостающие цены"<br>
                    Для предыдущих периодов цены не создаются.
                </small></p>

            </b-tab>

            <b-tab @show="onDiscountsShow('show')" @focus="onDiscountsShow('focus')" @change="onDiscountsShow('change')" @click="onDiscountsShow('click')">
                <template slot="title"><i class="fa fa-percent"></i> Скидки</template>

                <div class="btn-group pull-right mb-2">
                    <button class="btn btn-success btn-sm" @click="onAddDiscount">Добавить скидку</button>
                </div>

                <table class="table table-bordered table-hover table-sm">
                    <tr>
                        <th class="text-center" rowspan="2">№</th>
                        <th class="text-center" rowspan="2">Название и условия</th>
                        <th class="text-center" colspan="2">Период продажи</th>
                        <th class="text-center" colspan="2">Период путевки</th>
                        <th class="text-center" colspan="3">Скидка</th>
                        <th class="text-center" colspan="99">Операции</th>
                    </tr>
                    <tr>
                        <th class="text-center">Дата начала</th>
                        <th class="text-center">Дата окончания</th>
                        <th class="texttarifs-center">Дата заезда</th>
                        <th class="text-center">Дата выезда</th>
                        <th class="text-center">%</th>
                        <th class="text-center">сумма</th>
                        <th class="text-center">дней</th>
                        <th class="text-center"><i class="fa cui-lightbulb  text-secondary fa-lg"></i></th>
                        <th class="text-center"><i class="fa fa-edit text-secondary fa-lg"></i></th>
                        <th class="text-center"><i class="fa fa-copy text-secondary fa-lg"></i></th>
                        <th class="text-center"><i class="fa fa-trash text-secondary fa-lg"></i></th>
                    </tr>
                    <tr v-for="d in discounts" v-bind:key="d.id">
                        <td class="text-center">{{ d.id }}</td>
                        <td class="text-center"><h6>{{ d.title }}<template v-if="d.social"> (социальная)</template></h6> <span v-html="discountCoditions(d, rooms, programs)"></span> </td>
                        <td class="text-center">{{ printDate(d.sale_start_at) }}</td>
                        <td class="text-center">{{ printDate(d.sale_end_at) }}</td>
                        <td class="text-center">{{ printDate(d.start_at) }}</td>
                        <td class="text-center">{{ printDate(d.end_at) }}</td>
                        <td class="text-center">{{ d.value_percent }}</td>
                        <td class="text-center">{{ formatPriceKop(d.value_fixed) }}</td>
                        <td class="text-center">{{ d.value_days }}</td>
                        <td class="text-center" v-if="!!d.disabled_at"><a href="#" @click.prevent="enableDiscount(d)"><i class="cui-lightbulb text-secondary fa-lg"></i></a></td>
                        <td class="text-center" v-if="!d.disabled_at"><a href="#" @click.prevent="disableDiscount(d)"><i class="cui-lightbulb text-warning fa-lg"></i></a></td>
                        <td class="text-center"><a href="#" @click.prevent="showDiscountEditDialogId=d.id"><i class="fa fa-edit fa-lg text-success"></i></a></td>
                        <td class="text-center"><a href="#" @click.prevent="cloneDiscount(d)"><i class="fa fa-copy fa-lg text-primary"></i></a></td>
                        <td class="text-center"><a href="#" @click.prevent="onDeleteDiscount(d)"><i class="fa fa-trash fa-lg text-danger"></i></a></td>
                    </tr>
                </table>

            </b-tab>

            <b-tab @show="onQuotaShow('show')" @focus="onQuotaShow('focus')" @change="onQuotaShow('change')" @click="onQuotaShow('click')">
                <template slot="title">
                    <i class="icon-pie-chart"></i> Квоты
                </template>

                <div class="btn-group pull-right mb-2">
                    <button class="btn btn-success btn-sm" @click="onAddQuota()">Добавить квоту</button>
                </div>

                <table class="table table-bordered table-hover table-sm">
                    <tr>
                        <th class="text-center">№</th>
                        <th class="text-center">Номер</th>
                        <th class="text-center">От</th>
                        <th class="text-center">До</th>
                        <th class="text-center">Количество</th>
                        <th class="text-center" colspan="99">Операции</th>
                    </tr>
                    <tr v-for="quota in hquotas" v-bind:key="quota.id" >
                        <td class="text-center">{{ quota.id }}</td>
                        <td class="text-left">{{ quota.room_title }}
                            <small v-if="quota.comment"><br>{{ quota.comment }}</small>
                            <small v-if="quota.voucher_id"><br>Невыкупленная путевка <a :href="$router.resolve({ path:voucherPage(quota.voucher_id)}).href">{{quota.voucher_id}}</a></small>
                        </td>
                        <td class="text-center">{{ printDate(quota.begin_at) }}</td>
                        <td class="text-center">{{ printDate(quota.end_at) }}</td>
                        <td class="text-center">{{ quota.rooms_count }}</td>
                        <td class="text-center" v-if="!!quota.m_disabled">
                            <template v-if="!quota.voucher_id">
                                <a href="#" @click.prevent="enableQuota(quota)"><i class="cui-lightbulb text-secondary fa-lg"></i></a>
                            </template>
                        </td>
                        <td class="text-center" v-if="!quota.m_disabled">
                            <template v-if="!quota.voucher_id">
                                <a href="#" @click.prevent="disableQuota(quota)"><i class="cui-lightbulb text-warning fa-lg"></i></a>
                            </template>
                        </td>
                        <td class="text-center">
                            <template v-if="!quota.voucher_id">
                                <a href="#" @click.prevent="onEditQuota(quota)"><i class="fa fa-edit fa-lg text-success"></i></a>
                            </template>
                        </td>
                        <td class="text-center">
                            <template v-if="!quota.voucher_id">
                                <a href="#" @click.prevent="onDeleteQuota(quota)"><i class="fa fa-trash fa-lg text-danger"></i></a>
                            </template>
                        </td>
                    </tr>
                </table>

            </b-tab>


        </b-tabs>

        WID=82e2617d-b5b5-43f7-882d-41b18888c1e3

        <room-edit-dialog  v-model="showRoomEditDialogId" v-if="showRoomEditDialogId" :hotel_prop="hotel"  @reload_images="reloadImages"  @delete_image="onDeleteImage" ref="roomEditDialog" ></room-edit-dialog>
        <tarif-edit-dialog v-model="showProgramEditDialogId" v-if="showProgramEditDialogId" :hotel_prop="hotel" ></tarif-edit-dialog>
        <period-edit-dialog v-model="showPeriodEditDialogId" v-if="showPeriodEditDialogId" :hotel_prop="hotel"></period-edit-dialog>
        <discount-edit-dialog v-model="showDiscountEditDialogId" v-if="showDiscountEditDialogId" :all="{hotel:hotel, rooms:rooms, programs:programs, discounts:discounts}"></discount-edit-dialog>
        <quota-edit-dialog  v-model="showQuotaEditDialogId" v-if="showQuotaEditDialogId" :hotel_prop="hotel"  :hquotas_prop="hquotas"></quota-edit-dialog>


        <simple-dialog  v-model="showSimpleDialog"></simple-dialog>
        <price-edit-dialog :hotelx='hotel' v-model="showPriceEditDialogId" v-if="showPriceEditDialogId" @changed="onPriceChanged"></price-edit-dialog>

        <simple-dialog  v-model="showSimpleDialog"></simple-dialog>

        <small class="text-secondary">
            <br>
            showRoomEditDialogId {{showRoomEditDialogId}}<br>
            showPriceEditDialogId {{showPriceEditDialogId}}<br>
            showProgramEditDialogId {{showProgramEditDialogId}}<br>
            showPeriodEditDialogId {{showPeriodEditDialogId}}<br>
            showDiscountEditDialogId {{showDiscountEditDialogId}}<br>
        </small>

        <b-modal title="Подтвердите удаление цены" class="modal-danger" centered  v-model="deletePriceConfirmModal" ok-variant="danger" @ok="handlePriceDelete()">
            Вы собираетесь безвозвратно удалить цену <strong>"{{deletePriceConfirmTitle}}"</strong>.
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">нет, передумал</b-button>
                <b-button size="sm" variant="outline-danger" @click="ok()">да, удалить</b-button>
            </template>
        </b-modal>

        <b-modal title="Подтвердите удаление периода" class="modal-danger" centered  v-model="deletePeriodConfirmModal" ok-variant="danger" @ok="handlePeriodDelete()">
            Вы собираетесь безвозвратно удалить период <strong>"{{deletePeriodConfirmTitle}}"</strong>.
            Все связанные с периодом <strong>"{{deletePeriodConfirmTitle}}"</strong> цены  также будут удалены.
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">нет, передумал</b-button>
                <b-button size="sm" variant="outline-danger" @click="ok()">да, удалить</b-button>
            </template>
        </b-modal>

        <b-modal title="Подтвердите удаление программы" class="modal-danger" centered  v-model="deleteProgramConfirmModal" ok-variant="danger" @ok="handleProgramDelete()">
            Вы собираетесь безвозвратно удалить программу <strong>"{{deleteProgramConfirmTitle}}"</strong>.
            Все связанные с программой <strong>"{{deleteProgramConfirmTitle}}"</strong> цены и скидки также будут удалены.
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">нет, передумал</b-button>
                <b-button size="sm" variant="outline-danger" @click="ok()">да, удалить</b-button>
            </template>
        </b-modal>

        <b-modal title="Подтвердите удаление номера" class="modal-danger" centered  v-model="deleteRoomConfirmModal" ok-variant="danger" @ok="handleRoomDelete()">
            Вы собираетесь безвозвратно удалить номер <strong>"{{deleteRoomConfirmTitle}}"</strong>.
            Все связанные с номером <strong>"{{deleteRoomConfirmTitle}}"</strong> цены и скидки также будут удалены.
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">нет, передумал</b-button>
                <b-button size="sm" variant="outline-danger" @click="ok()">да, удалить</b-button>
            </template>
        </b-modal>


        <b-modal title="Подтвердите удаление скидки" class="modal-danger" centered  v-model="deleteDiscountConfirmModal" ok-variant="danger" @ok="handleDiscountDelete()">
            Вы собираетесь безвозвратно удалить скидку <strong>"{{deleteDiscountConfirmTitle}}"</strong>.
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">нет, передумал</b-button>
                <b-button size="sm" variant="outline-danger" @click="ok()">да, удалить</b-button>
            </template>
        </b-modal>

        <b-modal title="Подтвердите удаление квоты" class="modal-danger" centered  v-model="deleteQuotaConfirmModal" ok-variant="danger" @ok="handleQuotaDelete()">
            Вы собираетесь безвозвратно удалить квоты <strong>"{{deleteQuotaConfirmTitle}}"</strong>.
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">нет, передумал</b-button>
                <b-button size="sm" variant="outline-danger" @click="ok()">да, удалить</b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_company } from '@/functions/company.js';
    import { functions_program } from '@/functions/program.js';
    import { functions_room } from '@/functions_room.js';
    import { functions_period } from '@/functions_period.js';
    import { functions_discount } from '@/functions_discount.js';
    import { functions_price } from '@/functions_price.js';
    import { functions_hotel } from '@/functions/hotel.js';
    import { functions_hotel_data } from '@/functions_hotel_data.js';
    import { functions_city } from '@/functions_city.js';
    import { functions_booker } from '@/functions_booker.js';
    import { functions_quota } from '@/functions_quota.js';
    import { htype_functions } from '@/functions/htype.js';


    import {CONSTANTS} from '@/constants.js';
    import Vue from 'vue'
    import RoomEditDialog from '@/dialogs/RoomEditDialog'
    import QuotaEditDialog from '@/dialogs/QuotaEditDialog'
    import SimpleDialog from '@/dialogs/SimpleDialog'
    import ImagesUpload from '@/components/ImagesUpload'
    import TimeInput from '@/components/TimeInput'
    import {ClientTable, Event} from 'vue-tables-2'

    import PriceEditDialog from '@/dialogs/PriceEditDialog'
    import TarifEditDialog from '@/dialogs/TarifEditDialog'
    import PeriodEditDialog from '@/dialogs/PeriodEditDialog'
    import DiscountEditDialog from '@/dialogs/DiscountEditDialog'

    const VueUploadComponent = require('vue-upload-component')
    Vue.component('file-upload', VueUploadComponent)
    Vue.use(ClientTable)

    export default {
        name: 'NsbTechHotel',
        mixins: [functions, functions_loaders, functions_discount, functions_program, functions_room, functions_period,
            functions_price, functions_company, functions_hotel, functions_booker, functions_city, functions_hotel_data,functions_quota, htype_functions],
        components: {
            ImagesUpload,
            RoomEditDialog,
            QuotaEditDialog,
            SimpleDialog,
            ClientTable,
            TimeInput,
            TarifEditDialog,
            PeriodEditDialog,
            DiscountEditDialog,
            PriceEditDialog,
        },
        data() {
            return {
                hotel_id:null,
                showSimpleDialog:false,
                hotelImagesSaveUrl:null,

                showRoomEditDialogId:0,
                showPriceEditDialogId:0,
                showProgramEditDialogId:0,
                showPeriodEditDialogId:0,
                showDiscountEditDialogId:0,
                showQuotaEditDialogId:0,

                roomTableColumns: [ 'id', 'title', 'prof_obj_rooms_id', 'm_disabled', 'edit_room', 'clone_room', 'delete_room'],
                roomTableOptions: {
                    headings: {
                        id: 'ID',
                        title: 'наименование номера',
                        prof_obj_rooms_id: 'ID во внешней системе',
                        m_disabled: function(h) { return (
                            <i class="fa fa-pause-circle-o fa-lg" title="влючение/отключение номера"></i>
                        ) },
                        edit_room: function(h) { return (
                            <i class="fa fa-edit fa-lg" title="редактирование номера"></i>
                        ) },
                        clone_room: function(h) { return (
                            <i class="fa fa-clone fa-lg" title="копирование номера"></i>
                        ) },
                        delete_room: function(h) { return (
                            <i class="fa fa-trash fa-lg" title="удаление номера"></i>
                        ) },
                    },
                    filter: false,
                    filterable: [],
                    perPage:25,
                    perPageValues:[25,50,100],
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    rowClassCallback: this.latestRoomClass,
                    columnsClasses: { id:"", title:"", m_disabled: "text-center ", edit_room: "text-center ", delete_room: "text-center ", clone_room: "text-center ", prof_obj_rooms_id:""  },
                },
                programTableColumns: [ 'id', 'title', 'prof_obj_tariff_id', 'm_disabled', 'edit_program', 'clone_program', 'delete_program'],
                programTableOptions: {
                    headings: {
                        id: 'ID',
                        title: 'наименование программы',
                        prof_obj_tariff_id: 'ID во внешней системе',
                        m_disabled: function(h) { return (
                            <i class="fa fa-pause-circle-o fa-lg" title="влючение/отключение программы"></i>
                        ) },
                        edit_program: function(h) { return (
                            <i class="fa fa-edit fa-lg" title="редактирование программы"></i>
                        ) },
                        clone_program: function(h) { return (
                            <i class="fa fa-clone fa-lg" title="копирование программы"></i>
                        ) },
                        delete_program: function(h) { return (
                            <i class="fa fa-trash fa-lg" title="удаление программы"></i>
                        ) },
                    },
                    filter: false,
                    filterable: [],
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    perPage:25,
                    perPageValues:[25,50,100],
                    columnsClasses: { m_disabled: "text-center", edit_program: "text-center", delete_program: "text-center", clone_program: "text-center", },
                    rowClassCallback: this.latestTarifClass,
                },
                periodTableColumns: [ 'id', 'date_period_begin_iso', 'date_period_end_iso', 'title', 'm_disabled', 'edit_period', 'delete_period'],
                periodTableOptions: {
                    headings: {
                        id: '#',
                        title: 'наименование периода',
                        date_period_begin_iso: 'начало',
                        date_period_end_iso: 'конец',
                        m_disabled: function(h) { return (
                            <i class="fa fa-pause-circle-o fa-lg" title="влючение/отключение периода"></i>
                        ) },
                        edit_period: function(h) { return (
                            <i class="fa fa-edit fa-lg" title="редактирование периода"></i>
                        ) },
                        delete_period: function(h) { return (
                            <i class="fa fa-trash fa-lg" title="удаление периода"></i>
                        ) },
                    },
                    filter: false,
                    filterable: [],
                    sortable: ['date_period_begin_iso', 'date_period_end_iso'],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    perPage:25,
                    perPageValues:[25,50,100],
                    columnsClasses: { m_disabled: "text-center", edit_period: "text-center", delete_period: "text-center", },
                    rowClassCallback: this.latestPeriodClass,
                },
                priceTableColumns: [ 'checkbox', 'id', 'room.title', 'program.title',
                    'period.title', 'period.begin_at', 'period.end_at',
                    'price_place',
                    'price_extra',
                    'price_room',
                    'price_1perroom',
                    'm_disabled', 'edit_price', 'delete_price'],
                priceTableOptions: {
                    headings: {
                        id: '#',
                        title: 'наименование программы',
                        'period.begin_at': 'начало',
                        'period.end_at': 'конец',
                        'program.title': 'программа',
                        'period.title': 'период',
                        'room.title': 'номер',
                        price_place:'основное',
                        price_extra:'дополн',
                        price_room:'целиком',
                        price_1perroom:'1-местное',
                        checkbox:'',
                        m_disabled: function(h) { return (
                            <i class="cui-lightbulb" title="влючение/отключение периода"></i>
                        ) },
                        edit_price: function(h) { return (
                            <i class="fa fa-edit fa-lg" title="редактирование периода"></i>
                        ) },
                        delete_price: function(h) { return (
                            <i class="fa fa-trash fa-lg" title="удаление периода"></i>
                        ) },
                    },
                    sortable: ['room_title', 'program_title', 'date_period_begin_iso', 'date_period_end_iso'],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    filter: false,
                    filterable: [],
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    perPage:25,
                    perPageValues:[25,50,100],
                    columnsClasses: { m_disabled: "text-center", edit_price: "text-center", delete_price: "text-center", },
                    rowClassCallback: this.latestPriceClass,
                },
                checked_prices: [],
                checked_prices_all: false,
                visible_rows:null,

                bookers: [
                    {id:0, title:'НСБ'},
                    {id:1, title:'Профкурорт'}
                ],
                orgtypes: [
                    {id:1, title:'Юридическое лицо'},
                    {id:2, title:'Физическое лицо'}
                ],
                reward_types: [
                    {id:1, title:'По дате заезда'},
                    {id:2, title:'По дате выезда'},
                    {id:4, title:'По дате покупки'},
                    {id:3, title:'С учетом переходного периода'}
                ],
                invoice_types: [
                    {id:1, title:'Счет на полную сумму'},
                    {id:2, title:'Счет за вычетом вознаграждения'}
                ],
                payment_types: [
                    {id:1, title:'Оплата полной суммы'},
                    {id:2, title:'Оплата за вычетом вознаграждения'}
                ],

                roomFilter:null,
                programFilter:null,
                periodFilter:null,

                deleteRoomConfirmModal:false,
                deleteRoomConfirmTitle:null,
                deleteRoomConfirmRoom:null,
                deletePriceConfirmModal:false,
                deletePriceConfirmTitle:null,
                deletePriceConfirmPrice:null,
                deletePeriodConfirmModal:false,
                deletePeriodConfirmTitle:null,
                deletePeriodConfirmPeriod:null,
                deleteProgramConfirmModal:false,
                deleteProgramConfirmTitle:null,
                deleteProgramConfirmProgram:null,
                deleteDiscountConfirmModal:false,
                deleteDiscountConfirmTitle:null,
                deleteDiscountConfirmDiscount:null,
                deleteQuotaConfirmModal:false,
                deleteQuotaConfirmTitle:null,
                deleteQuotaConfirmQuota:null,


                ages: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],
                age_tarifs: [
                    {'id':0, title:'Базовый'},
                    {'id':1, title:'Льготный'},
                    {'id':2, title:'Младенцы бесплатно без места'},
                    {'id':3, title:'Младенцы - не допускаются'},
                    {'id':4, title:'Бесплатно с местом'},
                ]
            }
        },
        watch: {
            'addData.show'(show) {
                if (show) {
                    this.addData.name = '';
                    this.addData.type = '';
                    this.addData.content = '';
                }
            },
        },
        methods: {

            imagesFiltrator: function() {
                return function(element) {
                    return element.room_id === null;
                }
            },
            onDeleteImage: function (id) {
                console.log('HOTEL: onDeleteImage ' + id);
                this.deleteHotelImage(id);
                this.hotel.images = this.deleteFromListById(this.hotel.images, id);
                this.$forceUpdate();
                this.$refs['roomEditDialog'].$forceUpdate();
            },
            onUp: function (id) {
                let x = this.fHotelImages();
                let prev = null;
                let curr = null;
                for (let i=0; i<x.length; i++) {
                    prev=curr;
                    curr=x[i];
                    if (curr.id === id) {
                        if (prev!==null) {
                            console.log('replace ' + curr.id + ' ' + prev.id);
                            let t = prev.srt;
                            prev.srt = curr.srt;
                            curr.srt = t;
                            break;
                        }
                    }
                }
            },
            onDown: function (id) {
                let x = this.fHotelImages();
                let prev = null;
                let curr = null;
                for (let i=x.length-1; i>=0; i--) {
                    prev=curr;
                    curr=x[i];
                    if (curr.id === id) {
                        if (prev!==null) {
                            console.log('replace ' + curr.id + ' ' + prev.id);
                            let t = prev.srt;
                            prev.srt = curr.srt;
                            curr.srt = t;
                            break;
                        }
                    }
                }
            },
            reloadImages: function() {
                console.log("HOTEL: reload_images");
                this.throttle(1, 200, this.doReloadImages);
            },
            doReloadImages: function() {
                this.loadHotelImages();
            },
            onSaveImageState: function() {
                this.httpPrepare();
                this.$http.put(this.apiurl('hotel/image/save'), JSON.stringify({test:'test', images:this.hotel.images})).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success') {
                        console.log(response);
                    }
                    else {
                        this.error_log(response.error);
                    }
                }, this.httpError);
            },
            fHotelImages: function() {
                if (!this.is(this.hotel.images)) return null;
                return this.hotel.images.filter(this.imagesFiltrator()).sort((a, b) => (a.srt > b.srt) ? 1 : (a.srt === b.srt) ? ((a.srt > b.srt) ? 1 : -1) : -1 );
            },
            onCancel: function () {
                this.backOrRouteTo('/tech/hotels');
            },
            onApply: function () {
                this.saveHotel();
            },
            onSave: function () {
                let self = this;
                this.saveHotel(function(self) {
                    self.backOrRouteTo('/tech/hotels');
                }, this);
            },
            afterLoadHotel:function () {
                this.discounts = this.hotel.discounts;
                this.programs = this.hotel.programs;
                this.rooms = this.hotel.rooms;
                this.periods = this.hotel.periods;
                if (this.booker_id) {
                    this.loadBookerHotels(this.booker_id);
                }
                console.log(this.hotel.child_age1,this.hotel.child_age2,this.hotel.child_age3,this.hotel.child_age4,this.hotel.child_age5);
                // if (!this.is(this.hotel.child_age1)) { this.hotel.child_age1 = 17; }
                // if (!this.is(this.hotel.child_age2)) { this.hotel.child_age2 = 17; }
                // if (!this.is(this.hotel.child_age3)) { this.hotel.child_age3 = 17; }
                // if (!this.is(this.hotel.child_age4)) { this.hotel.child_age4 = 17; }
                // if (!this.is(this.hotel.child_age5)) { this.hotel.child_age5 = 17; }
                console.log(this.hotel.child_age1,this.hotel.child_age2,this.hotel.child_age3,this.hotel.child_age4,this.hotel.child_age5);
                this.onChangeAge1();
                console.log(this.hotel.child_age1,this.hotel.child_age2,this.hotel.child_age3,this.hotel.child_age4,this.hotel.child_age5);
                this.onChangeAge2();
                console.log(this.hotel.child_age1,this.hotel.child_age2,this.hotel.child_age3,this.hotel.child_age4,this.hotel.child_age5);
                this.onChangeAge3();
                console.log(this.hotel.child_age1,this.hotel.child_age2,this.hotel.child_age3,this.hotel.child_age4,this.hotel.child_age5);
                this.onChangeAge4();
                console.log(this.hotel.child_age1,this.hotel.child_age2,this.hotel.child_age3,this.hotel.child_age4,this.hotel.child_age5);
                this.onChangeAge5();
                console.log(this.hotel.child_age1,this.hotel.child_age2,this.hotel.child_age3,this.hotel.child_age4,this.hotel.child_age5);
            },
            onEnableRoom: function(room_id) {
                this.enableRoom(room_id, function (param, payload) {
                    let room =  param.self.getRoomById(param.room_id, param.self.rooms)
                    room.m_disabled = payload.m_disabled;
                }, {room_id:room_id,self:this})
            },
            onDisableRoom: function(room_id) {
                this.disableRoom(room_id, function (param, payload) {
                    let room =  param.self.getRoomById(param.room_id, param.self.rooms)
                    room.m_disabled = payload.m_disabled;
                }, {room_id:room_id,self:this})
            },
            onAddRoom: function() {
                this.createRoom(this.hotel.id, function (self, payload) {
                    self.rooms.push(payload);
                    self.showRoomEditDialogId = payload.id;
                }, this)
            },
            onCloneRoom: function(room) {
                this.cloneRoom(room.id, function (self, payload) {
                    self.rooms.push(payload);
                    self.showRoomEditDialogId = payload.id;
                }, this)
            },
            onDeleteRoom: function(room) {
                this.deleteRoomConfirmModal = true;
                this.deleteRoomConfirmTitle = room.title;
                this.deleteRoomConfirmRoom = room;
            },
            handleRoomDelete: function() {
                this.deleteRoom(this.deleteRoomConfirmRoom.id, function (self, payload) {
                    self.delRoomById(self.deleteRoomConfirmRoom.id, self.rooms);
                }, this)
            },
            onEnablePeriod: function(period_id) {
                this.enablePeriod(period_id, function (param, payload) {
                    let period =  param.self.getRoomById(param.period_id, param.self.periods)
                    period.m_disabled = payload.m_disabled;
                }, {period_id:period_id,self:this})
            },
            onDisablePeriod: function(period_id) {
                this.disablePeriod(period_id, function (param, payload) {
                    let period =  param.self.getRoomById(param.period_id, param.self.periods)
                    period.m_disabled = payload.m_disabled;
                }, {period_id:period_id,self:this})
            },
            onAddPeriod: function() {
                this.createPeriod(this.hotel.id, function (self, payload) {
                    self.periods.push(payload);
                    self.showPeriodEditDialogId = payload.id;
                }, this)
            },
            onClonePeriod: function(period) {
                this.clonePeriod(period.id, function (self, payload) {
                    self.periods.push(payload);
                    self.showPeriodEditDialogId = payload.id;
                }, this)
            },
            onDeletePeriod: function(period) {
                this.deletePeriodConfirmModal = true;
                this.deletePeriodConfirmTitle = period.title+ ' c ' + printDate(period.date_period_begin_iso) + ' до ' + printDate(period.date_period_end_iso);
                this.deletePeriodConfirmPeriod = period;
            },
            handlePeriodDelete: function() {
                this.deletePeriod(this.deletePeriodConfirmPeriod.id, function (self, payload) {
                    self.delPeriodById(self.deletePeriodConfirmPeriod.id, self.periods);
                }, this)
            },
            onEnableProgram: function(program_id) {
                this.enableProgram(program_id, function (param, payload) {
                    let program =  param.self.getProgramById(param.program_id, param.self.programs)
                    program.m_disabled = payload.m_disabled;
                }, {program_id:program_id,self:this})
            },
            onDisableProgram: function(program_id) {
                this.disableProgram(program_id, function (param, payload) {
                    let t =  param.self.getProgramById(param.program_id, param.self.programs)
                    t.m_disabled = payload.m_disabled;
                }, {program_id:program_id,self:this})
            },
            onAddProgram: function() {
                this.createProgram(this.hotel.id, function (self, payload) {
                    self.programs.push(payload);
                    self.showProgramEditDialogId = payload.id;
                }, this)
            },
            onCloneProgram: function(program) {
                this.cloneProgram(program.id, function (self, payload) {
                    self.programs.push(payload);
                    self.showProgramEditDialogId = payload.id;
                }, this)
            },
            onDeleteProgram: function(program) {
                this.deleteProgramConfirmModal = true;
                this.deleteProgramConfirmTitle = program.title;
                this.deleteProgramConfirmProgram = program;
            },
            handleProgramDelete: function() {
                this.deleteProgram(this.deleteProgramConfirmProgram.id, function (self, payload) {
                    console.log('deleteProfram payload ', payload);
                    self.delProgramById(self.deleteProgramConfirmProgram.id, self.programs);
                }, this)
            },

            onDeleteDiscount: function(discount) {
                this.deleteDiscountConfirmModal = true;
                this.deleteDiscountConfirmTitle = discount.title;
                this.deleteDiscountConfirmDiscount = discount;
                console.log('onDeleteDiscount discount ', discount);
            },
            handleDiscountDelete: function() {
                this.deleteDiscount(this.deleteDiscountConfirmDiscount, function (self, payload) {
                    self.resetDiscounts().loadDiscountsAll(self.hotel.id);
                }, this)
            },
            onAddDiscount: function() {
                this.addDiscount(function (self, discount) {
                    self.showDiscountEditDialogId = discount.id;
                }, this);
            },
            onDiscountsShow: function() {
                this.resetDiscounts().loadDiscountsAll(this.hotel.id);
            },

            onEditQuota: function(quota) {
                this.showQuotaEditDialogId = quota.id;
            },
            onAddQuota: function(quota) {
                this.addQuota(function (self, quota) {
                    self.showQuotaEditDialogId = quota.id;
                }, this)
            },
            onDeleteQuota: function(quota) {
                this.deleteQuotaConfirmModal = true;
                this.deleteQuotaConfirmTitle = quota.room_title + ' (' + quota.comment + ')';
                this.deleteQuotaConfirmQuota = quota;
                console.log('onDeleteQuota discount ', quota);
            },
            handleQuotaDelete: function() {
                this.deleteQuota(this.deleteQuotaConfirmQuota, function (self, payload) {
                    console.log('deleteQuota payload ', payload);
                    // self.delProgramById(this.deleteDiscountConfirmDiscount.id, self.programs);
                }, this)
            },
            onQuotaShow: function() {
                this.resetHquotas().loadHquotas(this.hotel.id);
            },

            onEnablePrice: function(price_id){
                this.enablePrice(price_id, function (param, payload) {
                    let price =  param.self.getPriceById(param.price_id, param.self.prices)
                    price.m_disabled = payload.m_disabled;
                }, {price_id:price_id,self:this})
            },
            onDisablePrice: function(price_id) {
                this.disablePrice(price_id, function (param, payload) {
                    let price =  param.self.getPriceById(param.price_id, param.self.prices)
                    price.m_disabled = payload.m_disabled;
                }, {price_id:price_id,self:this})
            },
            onAddPrices: function() {
                this.createPrice(this.hotel.id, function (self, payload) {
                    console.log('createPrice payload ', payload);
                    self.prices = payload;
                }, this)
            },
            onDeletePrice: function(price_id){
                this.deletePrice(price_id, function (param, payload) {
                    console.log('deletePrice payload ', payload);
                    param.self.delPriceById(param.price_id, param.self.prices);
                }, {price_id:price_id,self:this})
            },
            handlePriceDelete: function() {
                // onDeletePrice
                this.deletePriceConfirmModal = true;
                this.deletePriceConfirmTitle = null;
                this.deletePriceConfirmPrice = null;
            },
            onPriceChanged:function() {

            },
            onPricesShow:function (n) {
                this.resetPrices().loadAllPrices(this.hotel.id);
            },
            onChangeBooker: function () {
                if (this.hotel.booker_id) {
                    let self = this;
                    this.loadBookerHotels(this.hotel.booker_id);
                }
            },
            onChangeAge1 :function () {
                if (this.hotel.child_age1 < 17) {
                    if (this.hotel.child_age2 < this.xxxxxx1p()) {
                        this.hotel.child_age2 = this.xxxxxx1p();
                        this.onChangeAge2();
                    }
                }
                else {
                    this.hotel.child_age2 = 17;
                    this.hotel.child_age3 = 17;
                    this.hotel.child_age4 = 17;
                    this.hotel.child_age5 = 17;
                }
            },
            onChangeAge2 :function () {
                if (this.hotel.child_age2 < 17) {
                    if (this.hotel.child_age3 < this.xxxxxx2p()) {
                        this.hotel.child_age3 = this.xxxxxx2p();
                        this.onChangeAge3();
                    }
                }
                else {
                    this.hotel.child_age3 = 17;
                    this.hotel.child_age4 = 17;
                    this.hotel.child_age5 = 17;
                }
            },
            onChangeAge3 :function () {
                if (this.hotel.child_age3 < 17) {
                    if (this.hotel.child_age4 < this.xxxxxx3p()) {
                        this.hotel.child_age4 = this.xxxxxx3p();
                        this.onChangeAge4();
                    }
                }
                else {
                    this.hotel.child_age4 = 17;
                    this.hotel.child_age5 = 17;
                }
            },
            onChangeAge4 :function () {
                if (this.hotel.child_age4 < 17) {
                    if (this.hotel.child_age5 < this.xxxxxx4p()) {
                        this.hotel.child_age5 = this.xxxxxx4p();
                        this.onChangeAge5();
                    }
                }
                else {
                    this.hotel.child_age5 = 17;
                }
            },
            onChangeAge5 :function () {
            },
            xxxxxx1p: function () { return this.hotel.child_age1+1; },
            xxxxxx2p: function () { return this.hotel.child_age2+1; },
            xxxxxx3p: function () { return this.hotel.child_age3+1; },
            xxxxxx4p: function () { return this.hotel.child_age4+1; },
            xxxxxx5p: function () { return this.hotel.child_age5+1; },
            onCheckAll: function () {
                if (this.checked_prices_all) {
                    this.checked_prices = [];
                    this.visible_rows = this.$refs['pricesTable'].filteredData;
                    for (let i=0; i<this.visible_rows.length; i++) {
                        this.checked_prices.push(this.visible_rows[i].id);
                    }
                } else {
                    this.checked_prices = [];
                }
            },
            onDisableChecked: function () {
                this.disablePriceMulti(this.checked_prices, this.hotel.id, function (self, payload) {
                    self.checked_prices = [];
                    self.prices = payload.prices;
                }, this);
            },
            onEnableChecked: function () {
                this.enablePriceMulti(this.checked_prices, this.hotel.id, function (self, payload) {
                    self.checked_prices = [];
                    self.prices = payload.prices;
                }, this);
            },
            onResetChecked: function () {
                this.resetPriceMulti(this.checked_prices, this.hotel.id, function (self, payload) {
                    self.checked_prices = [];
                    self.prices = payload.prices;
                }, this);
            },
            onDeleteChecked: function () {
                this.deletePriceMulti(this.checked_prices, this.hotel.id, function (self, payload) {
                    self.checked_prices = [];
                    self.prices = payload.prices;
                }, this);
            },
        },

        computed: {
            hotelImageFields: function() {
                return ['url', 'srt', 'title', 'orig_fn'];
            },
            filtered_prices: function () {
                return this.filteredPrices(this.roomFilter,this.programFilter,this.periodFilter);
            },
            _nsb_contract_date_begin : {
                get: function () {
                    if (!this.is(this.hotel.nsb_contract_date_begin)) return null;
                    return new Date(this.hotel.nsb_contract_date_begin.slice(0, 10));
                },
                set: function (v) {
                    this.hotel.nsb_contract_date_begin = dateToISO(v);
                }
            },
            _nsb_contract_date_end : {
                get: function () {
                    if (!this.is(this.hotel.nsb_contract_date_end)) return null;
                    return new Date(this.hotel.nsb_contract_date_end.slice(0, 10));
                },
                set: function (v) {
                    this.hotel.nsb_contract_date_end = dateToISO(v);
                }
            },
            _date_interest_start_iso : {
                get: function () {
                    if (!this.is(this.hotel.date_interest_start_iso)) return null;
                    return new Date(this.hotel.date_interest_start_iso.slice(0, 10));
                },
                set: function (v) {
                    this.hotel.date_interest_start_iso = dateToISO(v);
                }
            },

            _periods: function () {
                return this.periods.sort(function  (a, b) { return (new Date(a.date_period_begin_iso)) < (new Date(b.date_period_begin_iso)); });
            },

            active_programs: function() {
                return this.programs.filter(el=>!el.m_disabled);
            },

            active_rooms: function() {
                return this.rooms.filter(el=>!el.m_disabled);
            },

            active_periods: function() {
                return this.periods.filter(el=>!el.m_disabled);
            },
        },

        created: function() {
            this.hotel_id = this.$router.currentRoute.params.hotel_id;
            this.loadHotelAll(this.hotel_id, this.afterLoadHotel);
            this.loadHquotas(this.hotel_id);
            this.hotelImagesSaveUrl = this.apiurl('hotel/'+this.hotel_id+'/saveimg');
            this.loadCities();
            this.loadHtypes();
            this.loadCompaniesHotels();
            this.loadDiseases();
            this.loadServices();
            Event.$on('test', function (data) {
                alert('test');
            });

            Event.$on('vue-tables.filter', function (data) {
                this.checked_prices = [];
            });
            Event.$on('vue-tables.sorted', function (data) {
                this.checked_prices = [];
            });
            Event.$on('vue-tables.pagination', function (data) {
                this.checked_prices = [];
            });

        },
    }
</script>

<style lang="scss"></style>

<style></style>
<!--Отдел бронирования и продаж: +7 (36563) 2-55-04 - круглосуточно Ежедневно с 8:00 до 17:00 (по местному времени): +7 (36563) 2-71-06 +7 (36563) 2-42-03 +7 978 927 44 49 +7 978 798 91 81 Круглосуточно: С мобильного телефона: +7 978 927 44 49 +7 978 798 91 81 Консультация врача: +7 978 839 12 95 +7 (36-->
<!--Московская область, г. Наро-Фоминск, Наро-Фоминский район, городское поселение Наро-Фоминск, у пос. д/о Бекасово-->
<!--Расположен в 5 км от поселка Домбай, все основные достопримечательности Домбая сосредоточены в радиусе 10 км-->
<!--Юго-Восток Подмосковья, г. Домодедово Домодедовский р-он, территория Объединенный санаторий «Подмосковье»-->
<!--belorus1@inbox.ru - приемная директора, belorus_11@inbox.ru - отдел маркетинга и бронирования, skype-->
<!--akvamarin_anapa@mail.ru, (akvamarin-spa@mail.ru-этой почты уже нет (28.03.2019 менеджер Кристина))-->
